<template>
  <div class="container">
    <h2 class="subtitulo">INSCRIPCIÓN A OFERTAS FORMADORAS</h2>
    <hr />
    <b-alert v-if="ofertas.length <= 0" variant="warning" dismissible show>
      Por el momento no se han publicado ofertas, este atento(a) en este apartado.
    </b-alert>
    <!--
    <b-alert variant="warning" dismissible show>
      Los grupos para inscripción se habilitarán a partir de las 15:00 hrs.
    </b-alert>
    -->
    

    <div>
      <b-card-group columns>
        <b-card v-for="oferta in ofertas" :key="oferta.idx" :title="oferta.nombre_curso" :img-src="
          //url + '/backassets/logos/' + oferta.img
          //'https://sifc.iea.edu.mx' + '/backassets/logos/' + oferta.img
          'https://sifc3.iea.edu.mx/logos/' + oferta.img
          " :sub-title="oferta.nombre_institucion" img-alt="Image" img-top img-height="auto" img-width="auto"
          tag="article" class="stCard cartaInfo">
          <b-card-text>
            {{ oferta.descripcion }}
          </b-card-text>

          <b-card-text>
            {{ oferta.descripcion_det }}
          </b-card-text>

          <button class="btn bg-2" @click="registroOferta(oferta)">Registrarme</button>
        </b-card>
      </b-card-group>
    </div>





    <RegistroOfertaDisponibleModal :ofertaSelected="ofertaSelected"></RegistroOfertaDisponibleModal>
    <MensajeRegistroModal></MensajeRegistroModal>
  </div>
</template>

<script>
//import axios from "axios";
import RegistroOfertaDisponibleModal from "../modals/registroOfertaDisponibleModal";
import MensajeRegistroModal from "../modals/mensajeRegistroModal";
import { queryIEASIS } from "../backIeasis/dbContextConexion";

export default {
  name: "OfertaDispComponent",
  components: {
    RegistroOfertaDisponibleModal,
    MensajeRegistroModal
  },
  data() {
    return {
      ofertas: [],
      ofertaSelected: { nombre_curso: "No seleccionado", grupos: [] },
      modalRegistroOfertaDisponible: false,
      modalMensajeRegistroUsuario: false,
      url: process.env.VUE_APP_URL,
    };
  },
  created() {
    this.getOfertas();
    //this.modalMensajeRegistroUsuario = true;
  },
  methods: {
    async getOfertas() {

      if (sessionStorage.getItem("perfil") == 'ADMIN') {
        //MOSTRAR A NIVEL GLOBAL TODAS LAS OFERTAS DE TIPO INSCRIPCIÓN ABIERTA A ADMINISTRADORES 
        const query2 = "WITH ofertas AS (SELECT a.*, b.nombre_curso, b.institucion_formadora, b.descripcion, b.descripcion_det, d.institucion_formadora AS nombre_institucion, b.activo, c.idnivel, d.img, e.idcodigo, (SELECT f.id_grupo, f.id_oferta, f.estatus, f.grupo, f.observacion, f.cupo FROM grupos f WHERE f.id_oferta = b.id_oferta FOR JSON PATH) AS grupos FROM oferta_formacion_asignacion a INNER JOIN oferta_formacion b ON a.id_oferta = b.id_oferta INNER JOIN niveles_educativos c ON a.id_nivel = c.idnivel INNER JOIN instituciones_formadoras d ON b.institucion_formadora = d.idinstitucion CROSS APPLY (SELECT TOP 1 idcodigo FROM funciones_SIPPE e WHERE e.idnivel = c.idnivel ORDER BY e.idcodigo) e WHERE b.activo = 1) SELECT * FROM ofertas FOR JSON PATH";
        const res2 = await queryIEASIS(query2)
        if (res2) {
          this.ofertas = res2
        }
        console.clear();
      }

      else {
        const query =
          "WITH ofertas AS (" +
          "SELECT a.*, b.nombre_curso, b.institucion_formadora, b.descripcion, b.descripcion_det, " +
          "d.institucion_formadora AS nombre_institucion, b.activo, c.idnivel, d.img, " +
          "e.idcodigo, " +
          "(SELECT f.id_grupo, f.id_oferta, f.estatus, f.grupo, f.observacion, f.cupo " +
          " FROM grupos f WHERE f.id_oferta = b.id_oferta FOR JSON PATH) grupos " +
          "FROM oferta_formacion_asignacion a " +
          "INNER JOIN oferta_formacion b ON a.id_oferta = b.id_oferta " +
          "INNER JOIN niveles_educativos c ON a.id_nivel = c.idnivel " +
          "INNER JOIN instituciones_formadoras d ON b.institucion_formadora = d.idinstitucion " +
          "INNER JOIN funciones_SIPPE e ON c.idnivel = e.idnivel " +
          "WHERE b.activo = 1" +
          "), " +

          "usuario AS ( " +
          "SELECT a.idusuario, a.usuario, b.id_funcion, b.CategoriadePago " +
          "FROM usuarios a " +
          "INNER JOIN SIPPE b ON a.usuario = b.curp " +
          ") " +

          "SELECT a.* " +
          "FROM ofertas a " +
          "WHERE " +

          /* IEA COMPLETO */
          "a.idcodigo = -3 " +

          "OR " +

          /* EDUCACIÓN BÁSICA (-1) */
          "(" +
          "a.idcodigo = -1 " +
          "AND EXISTS ( " +
          "    SELECT 1 " +
          "    FROM usuario u " +
          "    WHERE u.idusuario = " + sessionStorage.getItem("id") + " " +
          "    AND u.id_funcion IN (16,17,20,27,35,60,63,64,28,67,84,85,49,50,70,71,77,30,25,37,39,48,47,91,240,241,243,249,250,256) " +
          ") " +
          ") " +

          "OR " +

          /* DIRECTIVOS / ATP (-2) */
          "(" +
          "a.idcodigo = -2 " +
          "AND EXISTS ( " +
          "    SELECT 1 " +
          "    FROM usuario u " +
          "    WHERE u.idusuario = " + sessionStorage.getItem("id") + " " +
          "    AND u.id_funcion IN (20,27,30,70,6,37,39,49,50,84,85,249,250) " +
          ") " +
          ") " +

          "OR " +

          /* SUPERVISOR EDUCACIÓN INICIAL (-4) */
          "(" +
          "a.idcodigo = -4 " +
          "AND EXISTS ( " +
          "    SELECT 1 " +
          "    FROM usuario u " +
          "    WHERE u.idusuario = " + sessionStorage.getItem("id") + " " +
          "      AND u.id_funcion = 49 " +
          "      AND u.CategoriadePago = 'E0113' " +
          ") " +
          ") " +

          "OR " +

          /* FUNCIONES NORMALES */
          "a.idcodigo IN ( " +
          "    SELECT u.id_funcion " +
          "    FROM usuario u " +
          "    WHERE u.idusuario = " + sessionStorage.getItem("id") +
          ") " +

          "OR a.idnivel = 16 " +

          "FOR JSON PATH";

        const res = await queryIEASIS(query)
        console.log(res)
        if (res) {
          this.ofertas = res
        }
        //console.clear();
      }
    },


    registroOferta(ofertaSelected) {
      this.ofertaSelected = ofertaSelected;
      this.modalRegistroOfertaDisponible = true;
    },


  },
};
</script>
